import type { ComponentProps } from 'react';
import { createPortal } from 'react-dom';
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faSpinnerThird,
  faTriangleExclamation,
} from '@awesome.me/kit-4a6bf60416/icons/classic/regular';
import { Toaster as Sonner } from 'sonner';

import { Icon } from '@/components/ui/icon';
import { useMounted } from '@/hooks/use-mounted';
import { getDocument } from '@/lib/utils';

type ToasterProps = ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const mounted = useMounted();

  if (!mounted) return null;

  const toasterContent = (
    <Sonner
      theme="light"
      className="toaster group"
      closeButton={true}
      position="bottom-center"
      icons={{
        success: <Icon icon={faCircleCheck} className="text-primary" />,
        info: <Icon icon={faCircleInfo} className="text-primary" />,
        warning: <Icon icon={faCircleExclamation} className="text-amber-500" />,
        error: <Icon icon={faTriangleExclamation} className="text-destructive" />,
        loading: <Icon icon={faSpinnerThird} className="animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          closeButton: '!absolute !right-[-1rem] !left-auto !text-xl !size-6',
        },
      }}
      {...props}
    />
  );

  return createPortal(toasterContent, getDocument()?.body as Element);
};

export { Toaster };
